import { render, staticRenderFns } from "./TableQuotes.vue?vue&type=template&id=16ba9e44&scoped=true"
import script from "./TableQuotes.vue?vue&type=script&lang=js"
export * from "./TableQuotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ba9e44",
  null
  
)

export default component.exports